module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border",
    staticStyle: {
      "display": "flex",
      "padding": "0 30px 0 30px"
    }
  }, [_c('div', {
    staticStyle: {
      "flex": "auto"
    }
  }, [_c('h3', {
    staticClass: "box-title"
  }, [(_vm.siteDetails.url) ? _c('div', [_vm._v("\n                              Line Items For the Domain:\n                              "), _c('a', {
    staticStyle: {
      "font-weight": "bold",
      "font-size": "17px"
    },
    attrs: {
      "href": _vm.siteDetails.url,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.siteDetails.url))])]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', {
    staticClass: "box-title"
  }, [(_vm.siteDetails.publisher) ? _c('div', [_vm._v("\n                              Publisher:\n                              "), _c('a', {
    staticStyle: {
      "font-weight": "bold",
      "font-size": "17px"
    }
  }, [_vm._v(_vm._s(_vm.siteDetails.publisher))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex": "none",
      "display": "flex",
      "align-items": "end"
    }
  }, [(_vm.allLineItems.length > 0 && _vm.siteDetails.currency && _vm.siteDetails.currency.code) ? _c('h3', {
    staticClass: "box-title",
    staticStyle: {
      "margin-top": "7px"
    }
  }, [_vm._v("\n                          RTC Currency: " + _vm._s(_vm.siteDetails.currency.code) + "\n                      ")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    staticClass: "pull-right",
    staticStyle: {
      "margin-left": "10px",
      "margin-top": "7px"
    },
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.showExportParamas
    }
  }, [_vm._v("Export Params")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "atd-tags"
  }, [_c('div', {
    staticClass: "flex-sb"
  }, [_c('h4', {
    staticClass: "box-title"
  }, [_vm._v("Tags:")]), _vm._v(" "), _c('div', [_c('el-button', {
    staticClass: "pull-right",
    staticStyle: {
      "margin": "10px 0px 10px 10px"
    },
    attrs: {
      "type": "success",
      "disabled": _vm.allLineItems.filter(function (k) {
        return k.type.includes('tag');
      }).length == 0
    },
    on: {
      "click": _vm.showExportTags
    }
  }, [_vm._v("Export Tag")]), _vm._v(" "), _c('el-button', {
    staticClass: "pull-right",
    staticStyle: {
      "margin": "10px 0"
    },
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.showCreateTagDialogfunction($event)
      }
    }
  }, [_vm._v("Create Tag")])], 1)]), _vm._v(" "), (
    _vm.allLineItems.length > 0 &&
    _vm.allLineItems.filter(function (k) {
      return k.type.includes('tag');
    }).length > 0
  ) ? _c('div', _vm._l((_vm.allLineItems), function(item, index) {
    return (item.type.includes('tag')) ? _c('div', {
      key: index,
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.lineitemDivClick($event)
        }
      }
    }, [_c('div', {
      class: [
        item.suspend || item.budget_exhausted ?
        'isSuspendedTrueClass' :
        'isSuspendedFalseClass' ]
    }, [(_vm.siteDetails && (item.type !== 'unitag' && _vm.siteDetails['placement_targeting_' + item.type.toLowerCase()] && item.placement_text.length == 0)) ? _c('div', {
      staticClass: "row",
      staticStyle: {
        "width": "100%",
        "display": "flex",
        "justify-content": "center",
        "color": "red"
      }
    }, [_vm._v("\n                                          *disabled(No placement targeting enabled)\n                                      ")]) : _vm._e(), _vm._v(" "), (_vm.siteDetails && _vm.siteDetails['position_targeting_' + item.type.toLowerCase()] && item.positions.length == 0) ? _c('div', {
      staticClass: "row",
      staticStyle: {
        "width": "100%",
        "display": "flex",
        "justify-content": "center",
        "color": "red"
      }
    }, [_vm._v("\n                                          *disabled(No position targeting enabled)\n                                      ")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "row",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.lineitemHeadingClick(item)
        }
      }
    }, [_c('div', {
      staticClass: "col-md-2"
    }, [_c('div', {
      staticStyle: {
        "margin-bottom": "10px",
        "word-break": "break-word"
      }
    }, [_vm._v("\n                                                  Line item : " + _vm._s(item.name) + "\n                                              ")])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-1"
    }, [_c('div', {
      staticStyle: {
        "margin-bottom": "10px"
      },
      attrs: {
        "id": "litype"
      }
    }, [_vm._v("\n                                                  Type : " + _vm._s(item.type) + "\n                                              ")])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-2"
    }, [_c('div', {
      staticStyle: {
        "margin-bottom": "10px"
      },
      attrs: {
        "id": "bidcpm"
      }
    }, [_vm._v("\n                                                  Bid CPM Range : "), _c('br'), _vm._v(_vm._s(item.bid_cpm_min + ' $ - ' + item.bid_cpm_max + ' $') + "\n                                              ")])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-1"
    }, [_c('div', {
      staticStyle: {
        "margin-bottom": "10px"
      },
      attrs: {
        "id": "budget"
      }
    }, [_vm._v("\n                                                  Budget : " + _vm._s((item.budget || '') + ' $') + "\n                                              ")])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-1"
    }, [(item.budget_exhausted == true) ? _c('button', {
      staticClass: "\n                                                      el-button\n                                                      notes-box\n                                                      el-button--text el-button--small\n                                                      forcontract\n                                                  ",
      staticStyle: {
        "background": "white",
        "color": "black",
        "border": "1px solid black",
        "padding": "10px"
      },
      attrs: {
        "type": "success"
      },
      on: {
        "click": function($event) {
          return _vm.resumeExhaustedLineItem($event, item)
        }
      }
    }, [_vm._v("\n                                                  Resume\n                                              ")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "col-md-1"
    }, [_c('div', {
      staticStyle: {
        "margin-bottom": "10px"
      }
    }, [_c('el-switch', {
      attrs: {
        "active-color": "#13ce66",
        "inactive-color": "#ff4949"
      },
      on: {
        "change": function($event) {
          return _vm.lineitemStatus(item)
        }
      },
      model: {
        value: (item.active),
        callback: function($$v) {
          _vm.$set(item, "active", $$v)
        },
        expression: "item.active"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "col-md-2 text-center"
    }, [_c('el-tooltip', {
      attrs: {
        "content": "Duplicate Tag",
        "placement": "bottom"
      }
    }, [_c('button', {
      staticClass: "el-button notes-box el-button--text el-button--small",
      staticStyle: {
        "background": "none",
        "color": "black"
      },
      attrs: {
        "type": "success"
      },
      on: {
        "click": function($event) {
          return _vm.showDuplicateLineitemDialogfunction($event, item)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-copy",
      staticStyle: {
        "font-size": "17px"
      },
      attrs: {
        "aria-hidden": "true"
      }
    })])])], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-2 text-center"
    }, [_c('div', {
      staticStyle: {
        "margin-bottom": "10px",
        "display": "flex",
        "justify-content": "space-around"
      }
    }, [_c('el-tooltip', {
      attrs: {
        "content": "Notes",
        "placement": "bottom"
      }
    }, [_c('button', {
      staticClass: "el-button notes-box el-button--text el-button--small",
      staticStyle: {
        "background": "none",
        "color": "black"
      },
      attrs: {
        "type": "success"
      },
      on: {
        "click": function($event) {
          return _vm.createLineItemNotes($event, item)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-sticky-note",
      staticStyle: {
        "font-size": "17px"
      },
      attrs: {
        "aria-hidden": "true"
      }
    })])]), _vm._v(" "), _c('el-tooltip', {
      attrs: {
        "content": "Edit Lineitem",
        "placement": "bottom"
      }
    }, [_c('button', {
      staticClass: "el-button notes-box el-button--text el-button--small",
      staticStyle: {
        "background": "none",
        "color": "black"
      },
      attrs: {
        "type": "success"
      },
      on: {
        "click": function($event) {
          return _vm.editLineitem($event, item)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil",
      staticStyle: {
        "font-size": "17px"
      },
      attrs: {
        "aria-hidden": "true"
      }
    })])]), _vm._v(" "), (item.suspend == true) ? _c('button', {
      staticClass: "\n                                                          el-button\n                                                          notes-box\n                                                          el-button--text el-button--small\n                                                          forcontract\n                                                      ",
      staticStyle: {
        "background": "white",
        "color": "black",
        "border": "1px solid black",
        "padding": "10px"
      },
      attrs: {
        "type": "success"
      },
      on: {
        "click": function($event) {
          return _vm.resumeStage($event, item)
        }
      }
    }, [_vm._v("\n                                                      Resume\n                                                  ")]) : _vm._e()], 1)])]), _vm._v(" "), _c('el-tabs', {
      attrs: {
        "type": "border-card"
      },
      on: {
        "tab-click": function($event) {
          return _vm.lineitemHeadingClick(item)
        }
      },
      model: {
        value: (_vm.activeName),
        callback: function($$v) {
          _vm.activeName = $$v
        },
        expression: "activeName"
      }
    }, [_c('el-tab-pane', {
      attrs: {
        "label": "Details",
        "name": 'first_' + item.xid
      }
    }, [_c('LineItemDetails', {
      attrs: {
        "dimensions": _vm.dimensions,
        "item": item,
        "devices": _vm.devices,
        "browsers": _vm.browsers,
        "changeItemFormat": _vm.changeItemFormat,
        "countries": _vm.countries,
        "creativeList": _vm.creativeList
      }
    })], 1), _vm._v(" "), _c('el-tab-pane', {
      attrs: {
        "label": "Data",
        "name": 'second_' + item.xid
      }
    }, [_c('LineItemData', {
      attrs: {
        "eventLoader": _vm.isEventLoading,
        "revenueLoader": _vm.isRevenueLoading,
        "eventData": _vm.tableDataEvent,
        "revenueData": _vm.tableDataRevenue,
        "currentTime": _vm.timeNow
      }
    })], 1)], 1)], 1)]) : _vm._e()
  }), 0) : _c('div', [_vm._v("No Tags Created")])]), _vm._v(" "), _c('div', {
    staticClass: "atd-placements"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin": "0 0 10px 0",
      "display": "flex",
      "align-items": "center",
      "justify-content": "center"
    }
  }, [_c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "padding": "0"
    }
  }, [_c('h4', {
    staticClass: "box-title"
  }, [_vm._v("Line Items:")]), _vm._v(" "), _c('span', [_vm._v("No. of LineItems : " + _vm._s(_vm.allLineItems.length))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "padding": "0"
    }
  }, [_c('el-button', {
    staticClass: "pull-right",
    attrs: {
      "type": "success",
      "disabled": _vm.loading
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.showCreateLineitemDialogfunction($event)
      }
    }
  }, [_vm._v("Create Line Item")])], 1)]), _vm._v(" "), _vm._l((_vm.allLineItems), function(item) {
    return (!item.type.includes('tag')) ? _c('div', {
      key: item.id,
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.lineitemDivClick($event)
        }
      }
    }, [_c('div', {
      class: [
        item.suspend || item.budget_exhausted ?
        'isSuspendedTrueClass' :
        'isSuspendedFalseClass' ]
    }, [(_vm.siteDetails && _vm.siteDetails['placement_targeting_' + item.type.toLowerCase()] && item.placement_text.length == 0) ? _c('div', {
      staticClass: "row",
      staticStyle: {
        "width": "100%",
        "display": "flex",
        "justify-content": "center",
        "color": "red"
      }
    }, [_vm._v("\n                                      *disabled(No placement targeting enabled)\n                                  ")]) : _vm._e(), _vm._v(" "), (_vm.siteDetails && _vm.siteDetails['position_targeting_' + item.type.toLowerCase()] && item.positions.length == 0) ? _c('div', {
      staticClass: "row",
      staticStyle: {
        "width": "100%",
        "display": "flex",
        "justify-content": "center",
        "color": "red"
      }
    }, [_vm._v("\n                                      *disabled(No position targeting enabled)\n                                  ")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "row",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.lineitemHeadingClick(item)
        }
      }
    }, [_c('div', {
      staticClass: "col-md-2"
    }, [_c('div', {
      staticStyle: {
        "margin-bottom": "10px",
        "word-break": "break-word"
      }
    }, [_vm._v("\n                                              Line item : " + _vm._s(item.name) + "\n                                          ")])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-1"
    }, [_c('div', {
      staticStyle: {
        "margin-bottom": "10px"
      },
      attrs: {
        "id": "litype"
      }
    }, [_vm._v("Type : " + _vm._s(item.type))])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-2"
    }, [_c('div', {
      staticStyle: {
        "margin-bottom": "10px"
      },
      attrs: {
        "id": "bidcpm"
      }
    }, [_vm._v("\n                                              Bid CPM Range : "), _c('br'), _vm._v("\n                                              " + _vm._s(item.bid_cpm_min + ' $ - ' + item.bid_cpm_max + ' $') + "\n                                          ")]), _vm._v(" "), _c('div')]), _vm._v(" "), _c('div', {
      staticClass: "col-md-1"
    }, [_c('div', {
      staticStyle: {
        "margin-bottom": "10px"
      },
      attrs: {
        "id": "budget"
      }
    }, [_vm._v("\n                                              Budget : " + _vm._s((item.budget || '') + ' $') + "\n                                          ")])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-1"
    }, [(item.budget_exhausted == true) ? _c('button', {
      staticClass: "el-button notes-box el-button--text el-button--small forcontract",
      staticStyle: {
        "background": "white",
        "color": "black",
        "border": "1px solid black",
        "padding": "10px"
      },
      attrs: {
        "type": "success"
      },
      on: {
        "click": function($event) {
          return _vm.resumeExhaustedLineItem($event, item)
        }
      }
    }, [_vm._v("\n                                              Resume\n                                          ")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "col-md-1"
    }, [_c('div', {
      staticStyle: {
        "margin-bottom": "10px"
      }
    }, [_c('el-switch', {
      attrs: {
        "active-color": "#13ce66",
        "inactive-color": "#ff4949"
      },
      on: {
        "change": function($event) {
          return _vm.lineitemStatus(item)
        }
      },
      model: {
        value: (item.active),
        callback: function($$v) {
          _vm.$set(item, "active", $$v)
        },
        expression: "item.active"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "col-md-2 text-center"
    }, [_c('el-tooltip', {
      attrs: {
        "content": "Duplicate Lineitem",
        "placement": "bottom"
      }
    }, [_c('button', {
      staticClass: "el-button notes-box el-button--text el-button--small",
      staticStyle: {
        "background": "none",
        "color": "black"
      },
      attrs: {
        "type": "success"
      },
      on: {
        "click": function($event) {
          return _vm.showDuplicateLineitemDialogfunction($event, item)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-copy",
      staticStyle: {
        "font-size": "17px"
      },
      attrs: {
        "aria-hidden": "true"
      }
    })])])], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-2 text-center"
    }, [_c('div', {
      staticStyle: {
        "margin-bottom": "10px",
        "display": "flex",
        "justify-content": "space-around"
      }
    }, [_c('el-tooltip', {
      attrs: {
        "content": "Notes",
        "placement": "bottom"
      }
    }, [_c('button', {
      staticClass: "el-button notes-box el-button--text el-button--small",
      staticStyle: {
        "background": "none",
        "color": "black"
      },
      attrs: {
        "type": "success"
      },
      on: {
        "click": function($event) {
          return _vm.createLineItemNotes($event, item)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-sticky-note",
      staticStyle: {
        "font-size": "17px"
      },
      attrs: {
        "aria-hidden": "true"
      }
    })])]), _vm._v(" "), _c('el-tooltip', {
      attrs: {
        "content": "Edit Lineitem",
        "placement": "bottom"
      }
    }, [_c('button', {
      staticClass: "el-button notes-box el-button--text el-button--small",
      staticStyle: {
        "background": "none",
        "color": "black"
      },
      attrs: {
        "type": "success"
      },
      on: {
        "click": function($event) {
          return _vm.editLineitem($event, item)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil",
      staticStyle: {
        "font-size": "17px"
      },
      attrs: {
        "aria-hidden": "true"
      }
    })])]), _vm._v(" "), (item.suspend == true) ? _c('button', {
      staticClass: "\n                                                      el-button\n                                                      notes-box\n                                                      el-button--text el-button--small\n                                                      forcontract\n                                                  ",
      staticStyle: {
        "background": "white",
        "color": "black",
        "border": "1px solid black",
        "padding": "10px"
      },
      attrs: {
        "type": "success"
      },
      on: {
        "click": function($event) {
          return _vm.resumeStage($event, item)
        }
      }
    }, [_vm._v("\n                                                  Resume\n                                              ")]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
      staticClass: "p-r-15"
    }, [_c('el-tabs', {
      attrs: {
        "type": "border-card"
      },
      on: {
        "tab-click": function($event) {
          return _vm.lineitemHeadingClick(item)
        }
      },
      model: {
        value: (_vm.activeName),
        callback: function($$v) {
          _vm.activeName = $$v
        },
        expression: "activeName"
      }
    }, [_c('el-tab-pane', {
      attrs: {
        "label": "Details",
        "name": 'first_' + item.xid
      }
    }, [_c('LineItemDetails', {
      attrs: {
        "dimensions": _vm.dimensions,
        "item": item,
        "devices": _vm.devices,
        "browsers": _vm.browsers,
        "changeItemFormat": _vm.changeItemFormat,
        "countries": _vm.countries,
        "creativeList": _vm.creativeList
      }
    })], 1), _vm._v(" "), _c('el-tab-pane', {
      attrs: {
        "label": "Data",
        "name": 'second_' + item.xid
      }
    }, [_c('LineItemData', {
      attrs: {
        "eventLoader": _vm.isEventLoading,
        "revenueLoader": _vm.isRevenueLoading,
        "eventData": _vm.tableDataEvent,
        "revenueData": _vm.tableDataRevenue,
        "currentTime": _vm.timeNow
      }
    })], 1)], 1)], 1)])]) : _vm._e()
  }), _vm._v(" "), (_vm.allLineItems.length == 0) ? _c('div', [_c('h5', [_vm._v("Line items are not created")])]) : _vm._e()], 2)])])])]), _vm._v(" "), _c('el-dialog', {
    staticClass: "element-promt line-item-dialog",
    attrs: {
      "title": "Notes",
      "visible": _vm.showCreateLineItemNotes,
      "width": "40%",
      "before-close": _vm.handleCloseLineItemNotes
    },
    on: {
      "update:visible": function($event) {
        _vm.showCreateLineItemNotes = $event
      }
    }
  }, [_c('line-item-notes', {
    attrs: {
      "lineItemId": _vm.selectedItem
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "element-promt line-item-dialog",
    attrs: {
      "title": "Line item",
      "visible": _vm.showCreateLineitemDialog,
      "width": "40%",
      "before-close": _vm.handleCloseLineitem
    },
    on: {
      "update:visible": function($event) {
        _vm.showCreateLineitemDialog = $event
      }
    }
  }, [_c('div', {
    staticClass: "p-t-1 of-auto"
  }, [_c('h5', [_vm._v("Name")]), _vm._v(" "), _c('el-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "col-md-12",
    attrs: {
      "data-vv-delay": "1000",
      "name": "name",
      "type": "text",
      "placeholder": "Enter LineItem Name"
    },
    model: {
      value: (_vm.createLineItemForm.name),
      callback: function($$v) {
        _vm.$set(_vm.createLineItemForm, "name", $$v)
      },
      expression: "createLineItemForm.name"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('name')),
      expression: "errors.has('name')"
    }],
    staticClass: "help is-danger",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.errors.first('name')))])], 1), _vm._v(" "), (_vm.createLineItemForm.type.includes('tag')) ? _c('div', [_c('div', {
    staticClass: "p-t-1 of-auto"
  }, [_c('h5', [_vm._v("Is Universal Tag?")]), _vm._v(" "), _c('el-switch', {
    staticClass: "col-md-12",
    model: {
      value: (_vm.isUniTag),
      callback: function($$v) {
        _vm.isUniTag = $$v
      },
      expression: "isUniTag"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "p-t-1 of-auto"
  }, [_c('h5', [_vm._v("Enable")]), _vm._v(" "), _c('el-switch', {
    staticClass: "col-md-12",
    model: {
      value: (_vm.createLineItemForm.active),
      callback: function($$v) {
        _vm.$set(_vm.createLineItemForm, "active", $$v)
      },
      expression: "createLineItemForm.active"
    }
  })], 1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "p-t-1 of-auto"
  }, [_c('h5', [_vm._v("Vertical:")]), _vm._v(" "), _c('el-select', {
    staticClass: "col-md-12",
    attrs: {
      "placeholder": "Select"
    },
    model: {
      value: (_vm.createLineItemForm.vertical),
      callback: function($$v) {
        _vm.$set(_vm.createLineItemForm, "vertical", $$v)
      },
      expression: "createLineItemForm.vertical"
    }
  }, _vm._l((_vm.placementVertical), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1)]), _vm._v(" "), (!_vm.createLineItemForm.type.includes('tag')) ? _c('div', {
    staticClass: "p-t-1 of-auto"
  }, [_c('h5', [_vm._v("Type:")]), _vm._v(" "), _c('el-select', {
    staticClass: "col-md-12",
    attrs: {
      "placeholder": "Select"
    },
    on: {
      "change": _vm.setDevicesForAMP
    },
    model: {
      value: (_vm.createLineItemForm.type),
      callback: function($$v) {
        _vm.$set(_vm.createLineItemForm, "type", $$v)
      },
      expression: "createLineItemForm.type"
    }
  }, _vm._l((_vm.placementType), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "p-t-1 of-auto"
  }, [_c('h5', [_vm._v("Geo")]), _vm._v(" "), _c('el-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "param-set-input select-input col-md-12",
    attrs: {
      "multiple": "",
      "placeholder": "Select Country",
      "name": "Country",
      "filterable": ""
    },
    on: {
      "change": function($event) {
        return _vm.validateUnique('country')
      }
    },
    model: {
      value: (_vm.selectedCountries),
      callback: function($$v) {
        _vm.selectedCountries = $$v
      },
      expression: "selectedCountries"
    }
  }, _vm._l((_vm.countries), function(country) {
    return _c('el-option', {
      key: country.id,
      attrs: {
        "label": country.name,
        "value": country.id
      }
    })
  }), 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Country')),
      expression: "errors.has('Country')"
    }],
    staticClass: "help is-danger",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.errors.first('Country')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "p-t-1 of-auto"
  }, [_c('h5', [_vm._v("Device")]), _vm._v(" "), _c('el-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "param-set-input select-input col-md-12",
    attrs: {
      "multiple": "",
      "placeholder": "Select Device",
      "name": "Devices"
    },
    on: {
      "change": function($event) {
        return _vm.validateUnique('device')
      }
    },
    model: {
      value: (_vm.selectedDevices),
      callback: function($$v) {
        _vm.selectedDevices = $$v
      },
      expression: "selectedDevices"
    }
  }, _vm._l((_vm.devices), function(device) {
    return _c('el-option', {
      key: device.id,
      attrs: {
        "label": device.name,
        "value": device.id,
        "disabled": _vm.disabledDevice.indexOf(device.id) > -1
      }
    })
  }), 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Devices')),
      expression: "errors.has('Devices')"
    }],
    staticClass: "help is-danger",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.errors.first('Devices')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "p-t-1 of-auto"
  }, [_c('h5', [_vm._v("Browser")]), _vm._v(" "), _c('el-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "param-set-input select-input col-md-12",
    attrs: {
      "multiple": "",
      "placeholder": "Select Browsers",
      "name": "Browsers"
    },
    on: {
      "change": function($event) {
        return _vm.validateUnique('browser')
      }
    },
    model: {
      value: (_vm.selectedBrowsers),
      callback: function($$v) {
        _vm.selectedBrowsers = $$v
      },
      expression: "selectedBrowsers"
    }
  }, _vm._l((_vm.browsers), function(browser) {
    return _c('el-option', {
      key: browser.id,
      attrs: {
        "label": browser.name,
        "value": browser.id,
        "disabled": _vm.disabledBrowser.indexOf(browser.id) > -1
      }
    })
  }), 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Browsers')),
      expression: "errors.has('Browsers')"
    }],
    staticClass: "help is-danger",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.errors.first('Browsers')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "p-t-1 of-auto"
  }, [_c('h5', [_vm._v("Dimension")]), _vm._v(" "), (_vm.createLineItemForm.type.includes('tag')) ? _c('div', [_c('el-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "col-md-12",
    attrs: {
      "placeholder": "Select Dimensions",
      "name": "Dimensions",
      "multiple": "",
      "multiple-limit": 1,
      "filterable": ""
    },
    on: {
      "change": function($event) {
        _vm.validateUnique('dimension');
        _vm.getAllPositionsForDimension($event);
      },
      "remove-tag": function($event) {
        return _vm.updateCreativeList(_vm.createLineItemForm, $event)
      }
    },
    model: {
      value: (_vm.selectedDimensions),
      callback: function($$v) {
        _vm.selectedDimensions = $$v
      },
      expression: "selectedDimensions"
    }
  }, _vm._l((_vm.dimensions), function(dimension, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": ((dimension.width) + "X" + (dimension.height)),
        "value": dimension.id,
        "disabled": _vm.disabledSize.indexOf(dimension.id) > -1
      }
    })
  }), 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Dimensions')),
      expression: "errors.has('Dimensions')"
    }],
    staticClass: "help is-danger",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.errors.first('Dimensions')))])], 1) : _c('div', [_c('el-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "col-md-12",
    attrs: {
      "placeholder": "Select Dimensions",
      "name": "Dimensions",
      "multiple": "",
      "filterable": ""
    },
    on: {
      "change": function($event) {
        _vm.validateUnique('dimension');
        _vm.getAllPositionsForDimension($event);
      },
      "remove-tag": function($event) {
        return _vm.updateCreativeList(_vm.createLineItemForm, $event)
      }
    },
    model: {
      value: (_vm.selectedDimensions),
      callback: function($$v) {
        _vm.selectedDimensions = $$v
      },
      expression: "selectedDimensions"
    }
  }, _vm._l((_vm.dimensions), function(dimension, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": ((dimension.width) + "X" + (dimension.height)),
        "value": dimension.id,
        "disabled": _vm.disabledSize.indexOf(dimension.id) > -1
      }
    })
  }), 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Dimensions')),
      expression: "errors.has('Dimensions')"
    }],
    staticClass: "help is-danger",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.errors.first('Dimensions')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "p-t-1 of-auto"
  }, [_c('h5', [_vm._v("Creatives ("), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://scripts.atmtd.com/sib_preview/"
    }
  }, [_vm._v("Preview")]), _vm._v(")")]), _vm._v(" "), (_vm.selectedDimensions.length > 0) ? _c('div', _vm._l((_vm.selectedDimensions), function(dim, index) {
    return _c('div', {
      key: index,
      staticClass: "m-t-15 m-b-15"
    }, [_c('div', {
      staticClass: "dis-flex"
    }, [_c('span', {
      staticStyle: {
        "width": "75px"
      }
    }, [_vm._v(_vm._s(_vm.dimensions.length &&
      _vm.dimensions.filter(function (k) { return k.id == dim; })[0].width +
      'X' +
      _vm.dimensions.filter(function (k) { return k.id == dim; })[0].height) + "\n                              -\n                          ")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "68%"
      }
    }, [_c('el-select', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      staticClass: "col-md-12",
      attrs: {
        "placeholder": "Select Creative",
        "name": "Creatives",
        "filterable": ""
      },
      on: {
        "change": function($event) {
          return _vm.addCreativeToLineItem(_vm.createLineItemForm, index)
        }
      },
      model: {
        value: (_vm.createLineItemForm.creativeIds[index]),
        callback: function($$v) {
          _vm.$set(_vm.createLineItemForm.creativeIds, index, $$v)
        },
        expression: "createLineItemForm.creativeIds[index]"
      }
    }, _vm._l((_vm.getCreativeList(dim)), function(creative, idx) {
      return _c('el-option', {
        key: idx,
        attrs: {
          "label": creative.name,
          "value": creative.id
        }
      })
    }), 1)], 1)]), _vm._v(" "), (_vm.createLineItemForm.creative.length > index && _vm.createLineItemForm.creative[index]) ? _c('div', {
      staticClass: "dis-flex"
    }, [_c('span', {
      staticStyle: {
        "width": "75px"
      }
    }), _vm._v(" "), (_vm.createLineItemForm.creative[index].isS2S == true) ? _c('div', {
      staticStyle: {
        "width": "68%",
        "padding": "0 15px"
      }
    }, [_vm._v("\n                              Tag ID :"), _c('el-input', {
      model: {
        value: (_vm.createLineItemForm.creative[index].tagId),
        callback: function($$v) {
          _vm.$set(_vm.createLineItemForm.creative[index], "tagId", $$v)
        },
        expression: "createLineItemForm.creative[index].tagId"
      }
    })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (
      _vm.createLineItemForm.creative.length > index &&
      _vm.createLineItemForm.creative[index] &&
      _vm.createLineItemForm.creative[index].modify == true
    ) ? _c('div', {
      staticClass: "row",
      staticStyle: {
        "border-bottom": "1px solid #ececec",
        "padding-bottom": "19px"
      }
    }, [_c('div', {
      staticClass: "col-md-3 p-t-15"
    }, [_c('div', [_vm._v("Modified creative name:")]), _vm._v(" "), _c('el-input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required|alpha_dash'),
        expression: "'required|alpha_dash'"
      }],
      attrs: {
        "data-vv-delay": "1000",
        "name": "name",
        "type": "text",
        "placeholder": "Enter Creative Name"
      },
      model: {
        value: (_vm.createLineItemForm.creative[index].name),
        callback: function($$v) {
          _vm.$set(_vm.createLineItemForm.creative[index], "name", $$v)
        },
        expression: "createLineItemForm.creative[index].name"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-2 p-t-15"
    }, [_c('div', [_vm._v("Font-Size:")]), _vm._v(" "), _c('el-select', {
      attrs: {
        "filterable": ""
      },
      model: {
        value: (_vm.createLineItemForm.creative[index].font_size),
        callback: function($$v) {
          _vm.$set(_vm.createLineItemForm.creative[index], "font_size", $$v)
        },
        expression: "createLineItemForm.creative[index].font_size"
      }
    }, _vm._l((_vm.allFontSizes), function(fontSize, index) {
      return _c('el-option', {
        key: index,
        attrs: {
          "label": fontSize,
          "value": fontSize
        }
      })
    }), 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-1"
    }, [_c('div', [_vm._v("Font Color:")]), _vm._v(" "), _c('swatch', {
      staticStyle: {
        "width": "50px",
        "height": "50px"
      },
      attrs: {
        "colors": "text-advanced",
        "popover-to": "top",
        "show-fallback": ""
      },
      model: {
        value: (_vm.createLineItemForm.creative[index].font_color),
        callback: function($$v) {
          _vm.$set(_vm.createLineItemForm.creative[index], "font_color", $$v)
        },
        expression: "createLineItemForm.creative[index].font_color"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-1"
    }, [_c('div', [_vm._v("CTA Color:")]), _vm._v(" "), _c('swatch', {
      staticStyle: {
        "width": "50px",
        "height": "50px"
      },
      attrs: {
        "colors": "text-advanced",
        "popover-to": "top",
        "show-fallback": ""
      },
      model: {
        value: (_vm.createLineItemForm.creative[index].cta_color),
        callback: function($$v) {
          _vm.$set(_vm.createLineItemForm.creative[index], "cta_color", $$v)
        },
        expression: "createLineItemForm.creative[index].cta_color"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-2"
    }, [_c('div', [_vm._v("Background Color:")]), _vm._v(" "), _c('swatch', {
      staticStyle: {
        "width": "50px",
        "height": "50px"
      },
      attrs: {
        "colors": "text-advanced",
        "popover-to": "top",
        "show-fallback": ""
      },
      model: {
        value: (_vm.createLineItemForm.creative[index].background_color),
        callback: function($$v) {
          _vm.$set(_vm.createLineItemForm.creative[index], "background_color", $$v)
        },
        expression: "createLineItemForm.creative[index].background_color"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "creative-save-btn"
    }, [_c('el-button', {
      staticStyle: {
        "margin-top": "10px"
      },
      attrs: {
        "type": "success"
      },
      on: {
        "click": function($event) {
          return _vm.saveCreative(_vm.createLineItemForm.creative[index], index)
        }
      }
    }, [_vm._v("Save")])], 1)]) : _vm._e()])
  }), 0) : _c('div', [_vm._v("Select a dimension for creative association")])]), _vm._v(" "), (!_vm.isUniTag) ? _c('div', {
    staticClass: "p-t-1 of-auto"
  }, [_c('h5', [_vm._v("Placement")]), _vm._v(" "), _vm._l((_vm.createLineItemForm.placements), function(data, index) {
    return _c('div', {
      key: (index + "positioninput"),
      staticClass: "col-md-12 dis-flex"
    }, [_c('el-select', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      staticClass: "col-md-3",
      staticStyle: {
        "padding": "0 5px 5px 0"
      },
      attrs: {
        "clearable": "",
        "placeholder": "Select an Operator",
        "name": "Operator",
        "reserve-keyword": "",
        "allow-create": ""
      },
      on: {
        "remove-tag": function($event) {
          return _vm.convertObjToRegex('placements')
        },
        "change": function($event) {
          return _vm.convertObjToRegex('placements')
        }
      },
      model: {
        value: (_vm.createLineItemForm.placements[index].operator),
        callback: function($$v) {
          _vm.$set(_vm.createLineItemForm.placements[index], "operator", $$v)
        },
        expression: "createLineItemForm.placements[index].operator"
      }
    }, _vm._l(([
      ['Starts With', 'starts_with'],
      ['Ends With', 'ends_with'],
      ['Contains', 'contains'],
      ['Equals', 'equals'],
      ['Does Not Contain', 'does_not_contain'] ]), function(operator, index) {
      return _c('el-option', {
        key: index,
        attrs: {
          "label": operator[0],
          "value": operator[1]
        }
      })
    }), 1), _vm._v(" "), _c('el-input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      staticClass: "col-md-11",
      staticStyle: {
        "margin": "0 5px 0 0",
        "padding": "0px 5px 5px 5px"
      },
      attrs: {
        "data-vv-delay": "1000",
        "name": "placementName",
        "type": "text",
        "placeholder": "Enter Placement Name"
      },
      on: {
        "remove-tag": function($event) {
          return _vm.convertObjToRegex('placements')
        },
        "change": function($event) {
          return _vm.convertObjToRegex('placements')
        }
      },
      model: {
        value: (_vm.createLineItemForm.placements[index].data),
        callback: function($$v) {
          _vm.$set(_vm.createLineItemForm.placements[index], "data", $$v)
        },
        expression: "createLineItemForm.placements[index].data"
      }
    }), _vm._v(" "), (index === _vm.createLineItemForm.placements.length - 1) ? _c('el-button', {
      staticClass: "col-md-1",
      staticStyle: {
        "height": "100%",
        "text-align": "center",
        "padding-left": "0",
        "padding-right": "0"
      },
      attrs: {
        "type": "secondary"
      },
      on: {
        "click": function($event) {
          _vm.addNewItem(index, 'placements');
          _vm.convertObjToRegex('placements');
        }
      }
    }, [_vm._v("OR")]) : _c('el-button', {
      staticClass: "col-md-1",
      staticStyle: {
        "height": "100%",
        "text-align": "center",
        "padding-left": "0",
        "padding-right": "0"
      },
      attrs: {
        "type": "danger"
      },
      on: {
        "click": function($event) {
          _vm.createLineItemForm.placements.splice(index, 1);
          _vm.convertObjToRegex('placements');
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])], 1)
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "p-t-1 of-auto"
  }, [_c('h5', [_vm._v("Position")]), _vm._v(" "), _vm._l((_vm.createLineItemForm.positions), function(data, index) {
    return _c('div', {
      key: (index + "positioninput"),
      staticClass: "col-md-12 dis-flex"
    }, [_c('el-select', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      staticClass: "col-md-3",
      staticStyle: {
        "padding": "0 5px 5px 0"
      },
      attrs: {
        "clearable": "",
        "placeholder": "Select an Operator",
        "name": "Operator",
        "reserve-keyword": "",
        "allow-create": ""
      },
      on: {
        "remove-tag": function($event) {
          return _vm.convertObjToRegex('positions')
        },
        "change": function($event) {
          return _vm.convertObjToRegex('positions')
        }
      },
      model: {
        value: (_vm.createLineItemForm.positions[index].operator),
        callback: function($$v) {
          _vm.$set(_vm.createLineItemForm.positions[index], "operator", $$v)
        },
        expression: "createLineItemForm.positions[index].operator"
      }
    }, _vm._l(([
      ['Starts With', 'starts_with'],
      ['Ends With', 'ends_with'],
      ['Contains', 'contains'],
      ['Equals', 'equals'],
      ['Does Not Contain', 'does_not_contain'] ]), function(operator, index) {
      return _c('el-option', {
        key: index,
        attrs: {
          "label": operator[0],
          "value": operator[1]
        }
      })
    }), 1), _vm._v(" "), _c('el-select', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      staticClass: "col-md-11",
      staticStyle: {
        "margin": "0 5px 0 0",
        "padding": "0px 5px 5px 5px"
      },
      attrs: {
        "clearable": "",
        "allow-create": "",
        "remote": "",
        "remote-method": _vm.positionFilter,
        "placeholder": "Select or Add Position",
        "name": "Positions",
        "loading": _vm.positionsListLoading,
        "reserve-keyword": "",
        "filterable": ""
      },
      on: {
        "remove-tag": function($event) {
          return _vm.convertObjToRegex('positions')
        },
        "change": function($event) {
          return _vm.convertObjToRegex('positions')
        }
      },
      model: {
        value: (_vm.createLineItemForm.positions[index].data),
        callback: function($$v) {
          _vm.$set(_vm.createLineItemForm.positions[index], "data", $$v)
        },
        expression: "createLineItemForm.positions[index].data"
      }
    }, _vm._l((_vm.posOptions), function(pos, index) {
      return _c('el-option', {
        key: index,
        attrs: {
          "label": pos,
          "value": pos
        }
      })
    }), 1), _vm._v(" "), (index === _vm.createLineItemForm.positions.length - 1) ? _c('el-button', {
      staticClass: "col-md-1",
      staticStyle: {
        "height": "100%",
        "text-align": "center",
        "padding-left": "0",
        "padding-right": "0"
      },
      attrs: {
        "type": "secondary"
      },
      on: {
        "click": function($event) {
          _vm.addNewItem(index, 'positions');
          _vm.convertObjToRegex('positions');
        }
      }
    }, [_vm._v("OR")]) : _c('el-button', {
      staticClass: "col-md-1",
      staticStyle: {
        "height": "100%",
        "text-align": "center",
        "padding-left": "0",
        "padding-right": "0"
      },
      attrs: {
        "type": "danger"
      },
      on: {
        "click": function($event) {
          _vm.createLineItemForm.positions.splice(index, 1);
          _vm.convertObjToRegex('positions');
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])], 1)
  })], 2), _vm._v(" "), (_vm.createLineItemForm.type.includes('tag')) ? _c('div', {
    staticClass: "p-t-1 of-auto"
  }, [_c('h5', [_vm._v("Bid CPM(USD):")]), _vm._v(" "), _c('el-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|decimal:6'),
      expression: "'required|decimal:6'"
    }],
    staticClass: "col-md-12",
    attrs: {
      "type": "text",
      "data-vv-delay": "1000",
      "name": "Bid CPM(USD):",
      "rows": 10,
      "placeholder": "Enter ECPM"
    },
    model: {
      value: (_vm.createLineItemForm.bid_cpm_min),
      callback: function($$v) {
        _vm.$set(_vm.createLineItemForm, "bid_cpm_min", $$v)
      },
      expression: "createLineItemForm.bid_cpm_min"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Bid CPM(USD) Min:')),
      expression: "errors.has('Bid CPM(USD) Min:')"
    }],
    staticClass: "help is-danger",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.errors.first('Bid CPM(USD) Min:')))])], 1) : _c('div', [_c('div', {
    staticClass: "p-t-1 of-auto"
  }, [_c('h5', [_vm._v("Bid CPM(USD) Min:")]), _vm._v(" "), _c('el-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|decimal:6'),
      expression: "'required|decimal:6'"
    }],
    staticClass: "col-md-12",
    attrs: {
      "type": "text",
      "data-vv-delay": "1000",
      "name": "Bid CPM(USD) Min:",
      "rows": 10,
      "placeholder": "Enter Min ECPM"
    },
    model: {
      value: (_vm.createLineItemForm.bid_cpm_min),
      callback: function($$v) {
        _vm.$set(_vm.createLineItemForm, "bid_cpm_min", $$v)
      },
      expression: "createLineItemForm.bid_cpm_min"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Bid CPM(USD) Min:')),
      expression: "errors.has('Bid CPM(USD) Min:')"
    }],
    staticClass: "help is-danger",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.errors.first('Bid CPM(USD) Min:')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "p-t-1 of-auto"
  }, [_c('h5', [_vm._v("Bid CPM(USD) Max:")]), _vm._v(" "), _c('el-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|decimal:6'),
      expression: "'required|decimal:6'"
    }],
    staticClass: "col-md-12",
    attrs: {
      "type": "text",
      "data-vv-delay": "1000",
      "name": "Bid CPM(USD) Max:",
      "rows": 10,
      "placeholder": "Enter Max ECPM"
    },
    model: {
      value: (_vm.createLineItemForm.bid_cpm_max),
      callback: function($$v) {
        _vm.$set(_vm.createLineItemForm, "bid_cpm_max", $$v)
      },
      expression: "createLineItemForm.bid_cpm_max"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Bid CPM(USD) Max:')),
      expression: "errors.has('Bid CPM(USD) Max:')"
    }],
    staticClass: "help is-danger",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.errors.first('Bid CPM(USD) Max:')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "p-t-1 of-auto"
  }, [_c('h5', [_vm._v("Budget (USD):")]), _vm._v(" "), _c('el-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|decimal:6'),
      expression: "'required|decimal:6'"
    }],
    staticClass: "col-md-12",
    attrs: {
      "type": "text",
      "data-vv-delay": "1000",
      "name": "Budget (USD):",
      "rows": 10,
      "placeholder": "Enter Line item budget (USD)"
    },
    model: {
      value: (_vm.createLineItemForm.budget),
      callback: function($$v) {
        _vm.$set(_vm.createLineItemForm, "budget", $$v)
      },
      expression: "createLineItemForm.budget"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Budget (USD):')),
      expression: "errors.has('Budget (USD):')"
    }],
    staticClass: "help is-danger",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.errors.first('Budget (USD):')))])], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(!_vm.isEditLineitem) ? _c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.createLineItem($event)
      }
    }
  }, [_vm._v("Create Line item")]) : _c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.createLineItem($event)
      }
    }
  }, [_vm._v("Save")])], 1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "element-promt",
    attrs: {
      "title": "Export Params",
      "visible": _vm.showExportParamsDialog,
      "width": "40%",
      "before-close": _vm.handleCloseParama
    },
    on: {
      "update:visible": function($event) {
        _vm.showExportParamsDialog = $event
      }
    }
  }, [_c('div', {
    attrs: {
      "id": "paramsDivId"
    }
  }, [_c('div', [_c('h4', [_vm._v("Prebid Params:")]), _vm._v(" "), _c('h5', [_vm._v("siteId : " + _vm._s(this.siteDetails.uuid))]), _vm._v(" "), (_vm.allLineItems.length !== 0) ? _c('h5', [_vm._v("Placements:")]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.mappedLineItemsByType['prebid']), function(lItem, index) {
    return (lItem.placement_text.length) ? _c('div', {
      key: index,
      staticStyle: {
        "list-style-type": "inherit"
      }
    }, [(lItem.placement_text && lItem.placement_text.length) ? _c('ol', {
      staticStyle: {
        "margin": "0"
      }
    }, _vm._l((_vm.changeItemFormat(lItem.placement_text[0])), function(divt, index) {
      return _c('li', {
        key: index
      }, [(divt.data && divt.operator) ? _c('span', [_c('span', {
        staticClass: "p-l-20"
      }, [_vm._v("Operator: " + _vm._s(divt.hasOwnProperty('operator') && divt.operator) + " , Value:\n                                  " + _vm._s(divt.data ? divt.data : divt))])]) : _vm._e()])
    }), 0) : _vm._e()]) : _vm._e()
  }), _vm._v(" "), (_vm.mappedLineItemsByType['AMP'] && _vm.mappedLineItemsByType['AMP'].length > 0) ? _c('div', [(_vm.mappedLineItemsByType['prebid'] && _vm.mappedLineItemsByType['prebid'].length > 0) ? _c('hr') : _vm._e(), _vm._v(" "), _c('h4', [_vm._v("RTC Urls:")])]) : _vm._e(), _vm._v(" "), _c('ol', {
    staticClass: "m-l-20"
  }, _vm._l((_vm.mappedLineItemsByType['AMP']), function(lItem, index) {
    return _c('li', {
      key: index,
      staticStyle: {
        "list-style-type": "inherit"
      }
    }, [(lItem.positions.length == 0) ? _c('div', [_vm._v("\n                          Name: " + _vm._s(lItem.placement_text[0] || '') + "\n                          "), _c('div', {
      staticStyle: {
        "word-break": "break-word",
        "border-bottom": "1px solid #ececec"
      }
    }, [_vm._v("\n                              " + _vm._s(_vm.siteDetails.currency ?
      _vm.rtcUrl
      .replace('SITEID', _vm.siteDetails.uuid)
      .replace('PLACEMENTID', lItem.placement_text[0] || '')
      .replace('POSITION', '')
      .replace('CURRENCY', _vm.siteDetails.currency.code) :
      _vm.rtcUrl
      .replace('SITEID', _vm.siteDetails.uuid)
      .replace('POSITION', '')
      .replace('PLACEMENTID', lItem.placement_text[0] || '')
      .split('&cur')[0]) + "\n                          ")])]) : _vm._l((_vm.changeItemFormat(lItem.positions)), function(pos, id) {
      return _c('div', {
        key: id
      }, [_vm._v("\n                          Name:\n                          " + _vm._s(lItem.placement_text[0] + ' - ' + pos.data ? pos.data : pos) + "\n                          "), _c('div', {
        staticStyle: {
          "word-break": "break-word",
          "border-bottom": "1px solid #ececec"
        }
      }, [_vm._v("\n                              " + _vm._s(_vm.siteDetails.currency ?
        _vm.rtcUrl
        .replace('SITEID', _vm.siteDetails.uuid)
        .replace('PLACEMENTID', lItem.placement_text[0])
        .replace('POSITION', pos.data ? pos.data[0] : pos)
        .replace('CURRENCY', _vm.siteDetails.currency.code) :
        _vm.rtcUrl
        .replace('SITEID', _vm.siteDetails.uuid)
        .replace('POSITION', pos.data ? pos.data[0] : pos)
        .replace('PLACEMENTID', lItem.placement_text[0])
        .split('&cur')[0]) + "\n                          ")])])
    })], 2)
  }), 0)], 2), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.copiedToClipboardparams
    }
  }, [_c('i', {
    staticClass: "fa fa-clipboard",
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n              Copy To Clipboard\n          ")])], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "element-promt",
    attrs: {
      "title": "Export Tags",
      "visible": _vm.showExportTagDialog,
      "width": "40%",
      "before-close": _vm.handleCloseTags
    },
    on: {
      "update:visible": function($event) {
        _vm.showExportTagDialog = $event
      }
    }
  }, [(_vm.tagSelectPosOptions.length > 0) ? _c('div', [_c('div', {
    attrs: {
      "id": "paramsDivId"
    }
  }, _vm._l((_vm.tagSelectPosOptions), function(i, index) {
    return _c('div', {
      key: index
    }, [_vm._v("\n                      " + _vm._s(index + 1) + ". size:\n                      " + _vm._s(_vm.dimensions.filter(function (k) {
        return k.id == i.size;
      })[0].width +
      'x' +
      _vm.dimensions.filter(function (k) {
        return k.id == i.size;
      })[0].height) + ", position: " + _vm._s(i.positions) + ", placement: " + _vm._s(i.placement) + "\n                      "), _c('pre', {
      ref: "tag-code",
      refInFor: true,
      staticClass: "tag-code border border-gray-100",
      staticStyle: {
        "font-size": "12px",
        "margin-top": "0",
        "border-bottom-left-radius": "4px",
        "border-bottom-right-radius": "4px"
      }
    }, [_c('code', {
      staticClass: "language-html"
    }, [_vm._v("\n<script src=\"" + _vm._s('https://scripts.atmtd.com/js/tag.js?cb=%%CACHEBUSTER%%') + "\" async></script>\n<script>\n      window.tagData = {};\n      tagData.siteID = \"" + _vm._s(_vm.siteDetails.uuid) + "\";\n      tagData.position = \"" + _vm._s(i.positions) + "\";\n      tagData.size = \"" + _vm._s(_vm.dimensions.filter(function (k) {
      return k.id == i.size
    })[0].width + 'x' + _vm.dimensions.filter(function (k) {
      return k.id == i.size
    })[0].height) + "\";\n      tagData.placement = \"" + _vm._s(i.placement && "/*** Add placement params manually. ***/") + "\";\n      try {\n        (function(){var intr=window.setInterval(function(){if(window.atmtdTag){window.clearInterval(intr);new atmtdTag(window.tagData);}});})();\n      }\n      catch (e) {\n        console.log(e);\n      }\n</script>")])])])
  }), 0), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.copiedToClipboardparams
    }
  }, [_c('i', {
    staticClass: "fa fa-clipboard",
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                  Copy To Clipboard\n              ")])], 1) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2037104b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/admin/Adspotofbidders.vue
// module id = 667
// module chunks = 2